export default function getDuplicateName(input: string): string {
  const regex = /\((\d+)\)$/; // regex to extract the number on a string with format "something (2)"
  const match = input.match(regex);
  return match ? input.replace(regex, `(${parseInt(match[1], 10) + 1})`) : `${input} (1)`;
}
